import { supabase } from '@/integrations/supabase/client';

// Cache presales pipeline names per org to avoid repeated queries
const cache = new Map<string, { names: string[]; timestamp: number }>();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export async function fetchPresalesPipelineNames(orgId: string): Promise<string[]> {
  const cached = cache.get(orgId);
  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.names;
  }

  const { data } = await supabase
    .from('funnel_pipelines')
    .select('pipeline_name')
    .eq('organization_id', orgId)
    .eq('pipeline_type', 'presales')
    .eq('is_active', true);

  const names = (data || []).map(p => p.pipeline_name);
  cache.set(orgId, { names, timestamp: Date.now() });
  return names;
}

export function excludePresalesDeals<T extends { pipeline_display_name?: string | null; pipeline?: string | null }>(
  deals: T[],
  presalesNames: string[],
): T[] {
  if (presalesNames.length === 0) return deals;
  const lowerNames = new Set(presalesNames.map(n => n.toLowerCase()));
  return deals.filter(d => {
    const pipelineName = (d.pipeline_display_name || d.pipeline || '').toLowerCase();
    return !lowerNames.has(pipelineName);
  });
}

export function clearPresalesCache(orgId?: string) {
  if (orgId) {
    cache.delete(orgId);
  } else {
    cache.clear();
  }
}
